import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="25"
    height="28"
    viewBox="0 0 25 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 25.6667H3.11117C2.68339 25.6667 2.33339 25.3167 2.33339 24.8889V3.1111C2.33339 2.68333 2.68339 2.33333 3.11117 2.33333H12.4445V6.99999C12.4445 8.28333 13.4945 9.33333 14.7778 9.33333H19.4445V11.6667C19.4445 12.0944 19.7945 12.4444 20.2223 12.4444C20.6501 12.4444 21.0001 12.0944 21.0001 11.6667V8.55555C21.0001 8.55555 20.9923 8.52444 20.9923 8.50888C20.9923 8.43888 20.9767 8.37666 20.9534 8.31444C20.9534 8.29888 20.9534 8.27555 20.9456 8.25999C20.9456 8.25222 20.9301 8.24444 20.9301 8.23666C20.8912 8.1511 20.8445 8.07333 20.7745 8.0111L13.7745 1.00333C13.7045 0.933327 13.6267 0.88666 13.5489 0.847771C13.5412 0.847771 13.5334 0.832215 13.5256 0.832215C13.5101 0.832215 13.4945 0.832215 13.4712 0.824438C13.4089 0.801104 13.3467 0.793327 13.2767 0.785549C13.2612 0.785549 13.2456 0.777771 13.2301 0.777771H3.11117C1.82783 0.777771 0.777832 1.82777 0.777832 3.1111V24.8889C0.777832 26.1722 1.82783 27.2222 3.11117 27.2222H14.0001C14.4278 27.2222 14.7778 26.8722 14.7778 26.4444C14.7778 26.0167 14.4278 25.6667 14.0001 25.6667ZM18.3478 7.77777H14.7778C14.3501 7.77777 14.0001 7.42777 14.0001 6.99999V3.42999L18.3478 7.77777ZM3.88894 12.4444C3.88894 12.0167 4.23894 11.6667 4.66672 11.6667H12.4445C12.8723 11.6667 13.2223 12.0167 13.2223 12.4444C13.2223 12.8722 12.8723 13.2222 12.4445 13.2222H4.66672C4.23894 13.2222 3.88894 12.8722 3.88894 12.4444ZM3.88894 8.55555C3.88894 8.12777 4.23894 7.77777 4.66672 7.77777H10.1112C10.5389 7.77777 10.8889 8.12777 10.8889 8.55555C10.8889 8.98333 10.5389 9.33333 10.1112 9.33333H4.66672C4.23894 9.33333 3.88894 8.98333 3.88894 8.55555Z"
      fill="var(--tlx-color-azure-blue-400)"
    />
    <g clipPath="url(#clip0_15773_573)">
      <path
        d="M15.8282 16.3279C17.5638 14.5923 20.4367 14.5923 22.1723 16.3279L20.7957 17.7045H24.3868V14.1135L23.2496 15.2506C20.9154 12.9165 17.085 12.9165 14.7509 15.2506C13.4342 16.5673 12.8955 18.3628 13.0751 20.0985H14.5713C14.3918 18.7818 14.8107 17.3454 15.8282 16.3279Z"
        fill="var(--tlx-color-azure-blue-400)"
      />
      <path
        d="M24.9255 18.9015H23.4292C23.6088 20.2182 23.1898 21.6546 22.1724 22.6721C20.4367 24.4077 17.5639 24.4077 15.8282 22.6721L17.2048 21.2955H13.6138V24.8865L14.7509 23.7494C17.0851 26.0835 20.8557 26.0835 23.1898 23.7494C24.5664 22.4327 25.105 20.6372 24.9255 18.9015Z"
        fill="var(--tlx-color-azure-blue-400)"
      />
    </g>
    <defs>
      <clipPath id="clip0_15773_573">
        <rect
          width="12"
          height="12"
          fill="var(--tlx-surface-bg-surface)"
          transform="translate(13 13.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
